export default "__VITE_ASSET__DyDKZILy__"